import type { ImpactType } from '../impact';
import type { ImpactValues } from '../subscriptions/climate-action-workforce/impact';
import type { ProjectBreakdown, RetirementDetails } from '../certificates';

export type CertificateStatus = 'RENDERING' | 'READY' | 'FAILED';

export interface ImpactCertificate {
  id: number;
  userId: string;
  fromDate: string;
  toDate: string;
  impactTypes: ImpactType[];
  groupId: number | null;
  groupName: string | null;
  impactLabel: string | null;
  status: CertificateStatus;
  pdfStorageKey: string | null;
  impactOrderId: number | null;
  invoice: { ref: string } | null;
  createdAt: string;
  updatedAt: string;
}

export type CertificateRenderData = {
  userId: string;
  certificate: {
    id: number;
    isBespokeRetirement: boolean;
    retirementDetails?: RetirementDetails;
    fromDate: string;
    toDate: string;
    impactTypes: ImpactType[];
    groupId: number | null;
    groupName: string | null;
    impactLabel: string | null;
    status: string;
  };
  impactData: {
    totals: ImpactValues;
    projects: ProjectBreakdown[];
  };
  displayName: string;
  logoUrl?: string;
};

export interface ImpactCertificatesListResponse {
  certificates: ImpactCertificate[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
